import React from 'react';

const LoadingSpinner = ({ 
  size = 'medium', 
  text = 'Loading...', 
  fullScreen = false,
  className = '',
  showPaws = true 
}) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-8 h-8',
    large: 'w-12 h-12',
    xlarge: 'w-16 h-16'
  };

  const content = (
    <div className={`flex flex-col items-center justify-center ${fullScreen ? 'min-h-screen' : 'p-8'} ${className}`}>
      {showPaws && (
        <div className="relative">
          <div className="absolute -top-4 -left-4 animate-bounce">
            <span className="text-2xl">🐾</span>
          </div>
          <div className="absolute -top-4 -right-4 animate-bounce delay-300">
            <span className="text-2xl">🐾</span>
          </div>
        </div>
      )}
      
      <div className="relative">
        <div className={`${sizeClasses[size]} animate-spin rounded-full border-3 border-primary-200 border-t-primary-600 shadow-lg`}></div>
        <div className={`${sizeClasses[size]} absolute top-0 animate-pulse rounded-full border-3 border-transparent border-b-secondary-400 opacity-50`}></div>
      </div>
      
      {text && (
        <div className="mt-4 text-center">
          <p className="text-sm font-medium text-primary-700 animate-pulse">{text}</p>
          <div className="flex justify-center space-x-1 mt-2">
            <div className="w-2 h-2 bg-primary-400 rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-secondary-400 rounded-full animate-bounce delay-100"></div>
            <div className="w-2 h-2 bg-accent-400 rounded-full animate-bounce delay-200"></div>
          </div>
        </div>
      )}
    </div>
  );

  return fullScreen ? (
    <div className="fixed inset-0 z-50 bg-white bg-opacity-90 backdrop-blur-sm flex items-center justify-center">
      {content}
    </div>
  ) : content;
};

export default LoadingSpinner;